// import Swal from 'sweetalert2'
// import moment from 'moment'
import * as auth from './auth';

// import store from '../../store'

export function tryGet(getter: any) {
  try {
    return getter()
  } catch (error) {
    return undefined
  }
}

export const string = {
  trimHandle(handle: any) {
    if (!handle) return ''
    return handle
      .toLowerCase()
      .trim()
      .replace(/(\s)+/g, '-')
      .replace(/[^0-9a-z.-]+/g, '')
      .replace(/((-+(\.)*)|((\.)+-*))+/g, '-')
  }
}

export const array = {
  takePage(array: any[], pageNumber: number, size: number) {
    return array.slice(pageNumber * size, pageNumber * size + size)
  }
}

// export const date = {
//   lastWeek: () =>
//     moment()
//       .add(-1, 'week')
//       .toDate(),
//   lastMonth: () =>
//     moment()
//       .add(-1, 'month')
//       .toDate(),
//   nextHour: () =>
//     moment()
//       .add(1, 'hour')
//       .toDate(),
//   format: (date, format = 'llll') => moment(date).format(format)
// }

export const apiHelper = (baseUrl: any, { axios }) => {
  const request = (method: string, { path, headers, query, body }, { done, failed }) => {
    const req = {
      method,
      url: `${baseUrl}/${path}`,
      params: query,
      data: body,
      headers: headers
    }

    return axios(req)
      .then(({ data }) => data)
      .then((data) => {
        //console.log('----then data 2 helper')
        if (done) done(data)
        return data
      })
      .catch((error) => {
        // console.log('----error helper')
        // console.log(error)
        if (failed) failed(error)
        else handleError(error)
        throw error
      })
  }

  return {
    createAxiosResponseInterceptor() {
      // https://stackoverflow.com/a/53294310/10765202 - handler for expired auth token. Also handles an expired refresh token.
      // Intercepts a 401 error (expired token), resets token and retries API call.
      const interceptor = axios.interceptors.response.use(
        response => response,
        async error => {
          // console.log('=====error')
          // console.log(error)
          if (error.response.status === 400 ||
            error.response.status === 401 ||
            error.response.status === 402 ||
            error.response.status === 403 ||
            error.response.status === 500
          ) {
            if (error.response.data.code != null && error.response.data.code !== "") {
              return Promise.reject(error.response.data);
            } else {
              return Promise.reject(error.response);
            }
          } else {
            // console.log(`createAxiosResponseInterceptor ERROR: `, error)
            //Reject promise if usual error
            // if (error.response.status !== 401) {
            //   return Promise.reject(error);
            // }

            // const user = null
            // console.log(`createAxiosResponseInterceptor USER:`, user)

            axios.interceptors.response.eject(interceptor);

            // const reqIntercept = {
            //   method: 'GET',
            //   url: `http://localhost:3200/api/user/login`
            // }

            // SEND USER BACK TO KAIZEN TO REVERIFY
            // window.location.replace('https://api-kaizen-dev.kubota.ca/api/user/login/sso');
            //window.location.replace('http://localhost:3200/api/user/login/sso');
          }
        }
      );
    },
    setToken(token) {
      axios.setToken(token)
    },
    async get(path, query = {}, { done, failed } = { done: null, failed: null }) {
      const headers = await getHeaders()
      return request(
        'GET',
        {
          path,
          headers,
          query,
          body: undefined
        },
        { done, failed }
      )
    },
    async post(path, body = {}, contentType, { done, failed } = { done: null, failed: null }) {
      const headers = await getHeaders(contentType)
      return request(
        'POST',
        {
          path,
          headers,
          body,
          query: undefined
        },
        { done, failed }
      )
    },
    async put(path: string, body = {}, { done, failed } = { done: null, failed: null }) {
      const headers = await getHeaders()
      return request(
        'PUT',
        {
          path,
          headers,
          body,
          query: undefined
        },
        { done, failed }
      )
    },
    patch(path, body = {}, { headers = getHeaders(), done, failed } = { done: null, failed: null }) {
      return request(
        'PATCH',
        {
          path,
          headers,
          body,
          query: undefined
        },
        { done, failed }
      )
    },
    delete(path, query = {}, { headers = getHeaders(), done, failed } = { done: null, failed: null }) {
      return request(
        'DELETE',
        {
          path,
          headers,
          query,
          body: undefined
        },
        { done, failed }
      )
    }
  }
}

export const notify = (() => {
  // const improveUI = () => {
  //   $('.swal2-confirm')
  //     .removeAttr('class')
  //     .attr('class', 'btn btn-sm btn-primary px-4')

  //   $('.swal2-modal')
  //     .css('width', '400px')
  //     .css('border-radius', 'unset')
  //     .addClass('rounded')
  // console.log('error');
  // }

  return {
    success(message) {
      // Swal.fire({
      //   title: 'Done!',
      //   html: message,
      //   type: 'success',
      //   onRender: improveUI
      // })
    },

    error(message, title) {
      // Swal.fire({
      //   title: title || 'Oops...',
      //   html: message,
      //   type: 'error',
      //   onRender: improveUI
      // })
    },

    validationError(error, { translate } = { translate: null }) {
      let html = ''
      for (let i = 0; i < error.details.length; i++) {
        const detail = error.details[i]
        const childError = `${detail.key} ${detail.message}`
        const errorMessage =
          tryGet(() => translate(childError)) ||
          `<span className="text-capitalize"><strong>${detail.label ||
          detail.key} </strong></span><span>${detail.message}.</span>`

        html += `<span>${errorMessage}</span><br/>`
      }

      // Swal.fire({
      //   type: 'error',
      //   title: 'Invalid data',
      //   html,
      //   onRender: improveUI
      // })
    }
  }
})()

export function handleError(error, { translate } = { translate: null }) {
  if (!error.isAxiosError) {
    notify.error(`Something went wrong, please try again.`, 'Error')
  }

  const status = tryGet(() => error.response.status)
  const errorDetails = tryGet(() => error.response.data) || {}

  switch (status) {
    case 400:
      notify.error(
        errorDetails.message || 'Unable to process the request.',
        'Bad Request'
      )
      break

    case 401:
      notify.error(errorDetails.message || 'Access denied!', 'Unauthorized')
      break

    case 403:
      notify.error(errorDetails.message || 'You need to login!', 'Forbidden')
      break

    case 404:
      notify.error(errorDetails.message || 'Resource not found!', 'Not Found')
      break

    case 422:
      if (errorDetails.type === 'ValidationError')
        notify.validationError(errorDetails, { translate })
      else
        notify.error(
          errorDetails.message || 'Unable to process the request!',
          'Invalid Data'
        )
      break

    default:
      if (errorDetails.isUserError) {
        switch (errorDetails.type) {
          case 'ValidationError':
            notify.validationError(errorDetails, { translate })
            break

          default:
            notify.error(errorDetails.message, 'Error')
        }
      } else {
        notify.error(`Something went wrong, please try again.`, 'Error')
      }
  }
}

export async function getHeaders(contentType?: string) {
  const authString = btoa(process.env.REACT_APP_API_USERNAME + ":" + process.env.REACT_APP_API_PASSWORD)
  return {
    'Authorization': `Basic ${authString}`,
    'Content-Type': contentType ? contentType : 'application/json'
  }
}